<div class="share-presence-with-colleagues">
  <h4 class="details-title">Detalle de coincidencia con compañeros</h4>

  @if (sectionsData().length === 0) {
    @if (presenceData()?.reason_max_value) {
      <p class="no-data">{{ presenceData()?.reason_max_value }}</p>
    } @else {
      <p class="no-data">No hay datos disponibles</p>
    }
  } @else {
    <div class="categories-list">
      @for (section of sectionsData(); track section.name) {
        <div class="category-item">
          <div class="category-header">
            <span class="category-name-row">
              <span class="category-name">{{ section.name }}</span>
              @if (section.progressBarTooltip) {
                <mat-icon
                  class="info-icon"
                  [matTooltip]="section.progressBarTooltip"
                  matTooltipPosition="above"
                  matTooltipShowDelay="300"
                  matTooltipClass="kpi-tooltip"
                  >info</mat-icon
                >
              }
            </span>
            @if (section.expected_hours > 0) {
              <span class="category-hours">
                {{ section.done_hours | number: '1.1-1' }}h / {{ section.expected_hours | number: '1.1-1' }}h
              </span>
            }
          </div>

          @if (section.expected_hours > 0) {
            <div class="progress-bar-container">
              <div class="progress-bar-track">
                <div
                  class="progress-bar-fill"
                  [style.width.%]="section.percentage"
                  [style.background-color]="section.progressBarColor"
                ></div>
              </div>
              <div class="progress-bar-labels">
                <span>0%</span>
                <span class="value">{{ section.percentage | number: '1.0-0' }}%</span>
                <span>100%</span>
              </div>
            </div>
          } @else {
            <p class="no-data">No hay datos disponibles</p>
          }
        </div>
        @if (section.isWarning) {
          <div class="warning-message">
            <mat-icon class="warning-message-icon">warning_outline</mat-icon>
            <div class="warning-message-text">
              La previsión está por debajo del <strong>{{ goodThreshold() | number: '1.0-0' }}%</strong>. Considera ajustar tus horarios o
              coordinarte con tus compañeros.
            </div>
          </div>
        }
      }

      <button mat-stroked-button (click)="openDayDetailsDialog()">
        <mat-icon>visibility</mat-icon>
        Ver detalle por día
      </button>
    </div>
  }
</div>
